
// SVG Icon: splitter
export default { id: "terriajs-splitter" };
export const id = "terriajs-splitter";
export const name = "splitter";
